import { normalizeLocale, type SupportedLocale } from '@/i18n/config';

type IdleVoiceDockCopy = { callYourImai: string; hideAvatar: string };

const LABELS: Record<SupportedLocale, IdleVoiceDockCopy> = {
  en: {
    callYourImai: 'Call {name}',
    hideAvatar: 'Hide avatar until refresh',
  },
  ar: {
    callYourImai: 'اتصل بـ {name}',
    hideAvatar: 'إخفاء الصورة الرمزية حتى تحديث الصفحة',
  },
  de: {
    callYourImai: '{name} anrufen',
    hideAvatar: 'Avatar bis zum Neuladen ausblenden',
  },
  es: {
    callYourImai: 'Llamar a {name}',
    hideAvatar: 'Ocultar avatar hasta recargar la página',
  },
  fr: {
    callYourImai: 'Appeler {name}',
    hideAvatar: 'Masquer l’avatar jusqu’au rechargement',
  },
  hi: {
    callYourImai: '{name} को कॉल करें',
    hideAvatar: 'पेज रीफ़्रेश होने तक अवतार छिपाएँ',
  },
  id: {
    callYourImai: 'Hubungi {name}',
    hideAvatar: 'Sembunyikan avatar hingga halaman dimuat ulang',
  },
  it: {
    callYourImai: 'Chiama {name}',
    hideAvatar: 'Nascondi avatar fino al ricaricamento',
  },
  ja: {
    callYourImai: '{name} に通話',
    hideAvatar: '再読み込みまでアバターを非表示',
  },
  ko: {
    callYourImai: '{name}에 전화하기',
    hideAvatar: '새로고침할 때까지 아바타 숨기기',
  },
  'pt-BR': {
    callYourImai: 'Ligar para {name}',
    hideAvatar: 'Ocultar avatar até atualizar a página',
  },
  ru: {
    callYourImai: 'Позвонить {name}',
    hideAvatar: 'Скрыть аватар до обновления страницы',
  },
  vi: {
    callYourImai: 'Gọi {name}',
    hideAvatar: 'Ẩn hình đại diện đến khi tải lại trang',
  },
  zh: {
    callYourImai: '呼叫 {name}',
    hideAvatar: '隐藏头像直到刷新页面',
  },
  'zh-TW': {
    callYourImai: '呼叫 {name}',
    hideAvatar: '隱藏頭像直到重新整理頁面',
  },
};

export function getIdleVoiceDockCopy(
  locale: string | null | undefined,
  assistantName: string
): IdleVoiceDockCopy {
  const copy = LABELS[normalizeLocale(locale)];
  return {
    hideAvatar: copy.hideAvatar,
    callYourImai: copy.callYourImai.replace('{name}', () => assistantName),
  };
}
